export const ITINERARY_CARD_NAME = "itinerary";
export const SHUTTLE_DESTINATIONS_CARD_NAME = "shuttle_destinations";
export const AMENITIES_CARD_NAME = "amenities";
export const CLASSES_AND_FARES_CARD_NAME = "classes_and_fares";
export const REVIEWS_CARD_NAME = "reviews";

export type TicketOptionsCardName =
  | typeof ITINERARY_CARD_NAME
  | typeof SHUTTLE_DESTINATIONS_CARD_NAME
  | typeof AMENITIES_CARD_NAME
  | typeof CLASSES_AND_FARES_CARD_NAME
  | typeof REVIEWS_CARD_NAME;
